/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import router from "../router";
import user from "../../public/user.json";

const actions = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit("UPDATE_STARRED_PAGE", payload);
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_LIMITED", list);
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_MORE", list);
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit("TOGGLE_CONTENT_OVERLAY");
  },
  updateTheme({ commit }, val) {
    commit("UPDATE_THEME", val);
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  /*updateUserInfo({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },*/
  initAuth({ commit }) {
    //alert(info)
    console.log(window.location);
    if (localStorage.getItem("tokenId")) {
      let veriler = JSON.parse(localStorage.getItem("userInfo"));
      //commit('setToken',veriler[0])
      //router.push('/')
    }
    if (window.location.pathname == "/muhasebe-kategorileri") {
      router.push("/muhasebe-kategorileri");
    } else {
      router.push("/login");
    }
  },
  mailControl({ commit }, payload) {
    //"in")
    var serviceAddressOnline = "";
    var vm = this;
    var vs = payload.vs;

    const soap = require("soap");
    const data = [];
    const url = user.userService;
    const args = {
      ALICI: payload.email,
      MESAJ: payload.mesaj,
      KONU: "Mail kontrol kodu"
    };
    soap.createClient(url, function(err, client) {
      client.mailGonder(args, function(err, result) {
        if (vm.veriler == "-1" || vm.veriler == "") {
          vs.notify({
            title: "Hatalı Giriş",
            text: "Mail adresi yanlış olabilir",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        } else {
          vs.notify({
            title: "Mail gönderildi",
            text: "Mail adresinizi kontrol ediniz.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        }
      });
    });
  },
  login({ commit }, payload) {
    var vs = payload.vs;
    var vm = this;
    var serviceAddressOnline = "";
    const soap = require("soap");
    const data = [];
    const url = user.userService;
    const args = {
      USERNAME: payload.userDetails.email
    };

    return new Promise((resolve, reject) => {
      soap.createClient(url, function(err, client) {
        client.B2B_GET_USER(args, function(err, result) {
          if (result.B2B_GET_USERResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          try {
            vm.veriler = JSON.parse(result.B2B_GET_USERResult);

            resolve(vm.veriler);
            console.log(vm.veriler);

            if (vm.veriler == "") {
              // alert("in")
              vs.notify({
                iconPack: "feather",
                color: "danger",
                icon: "icon-alert-circle",
                title: "Hatalı Giriş",
                text: `Girilen bilgilere uygun mail adresi bulunamadı`
              });
            } else {
              data["servisAdresi"] = user.userService;
              data["id"] = vm.veriler[0].USERID;
              data["employeeid"] = vm.veriler[0].EMPLOYEEID;
              data["EMPLOYEEID"] = vm.veriler[0].EMPLOYEEID;

              data["firmaAdi"] = vm.veriler[0].EMPLOYEENAME;
              data["COMPANYNAME"] = user.userName;

              data["tokenId"] = vm.veriler[0].TOKEN;

              data["COMPANYID"] = vm.veriler[0].COMPANYID;
              data["EMPLOYEENO"] = vm.veriler[0].EMPLOYEENO;
              data["EMAIL"] = vm.veriler[0].EMAIL;
              data["USERLONGNAME"] = vm.veriler[0].USERLONGNAME;
              var result = vm.veriler[0].TOKEN.substring(1, 7);
              data["mailCode"] = result;
              data["loginpng"] = user.userLogo;
              data["GROUPCODE"] = vm.veriler[0].GROUPCODE;

              /*   data['email'] = payload.userDetails.email*/
console.log(data)
              commit("setToken", data);
              localStorage.setItem("servisAdresi", data["servisAdresi"]);
              localStorage.setItem("id", data["id"]);
              localStorage.setItem("employeeid", data["employeeid"]);
              localStorage.setItem("firmaAdi", data["firmaAdi"]);
              localStorage.setItem("COMPANYNAME", data["COMPANYNAME"]);
              localStorage.setItem("firmaAdi", data["firmaAdi"]);

              localStorage.setItem("tokenId", data["tokenId"]);
              localStorage.setItem("COMPANYID", data["COMPANYID"]);
              localStorage.setItem("EMPLOYEENO", data["EMPLOYEENO"]);
              localStorage.setItem("EMAIL", data["EMAIL"]);

              localStorage.setItem("USERLONGNAME", data["USERLONGNAME"]);
              localStorage.setItem("GROUPCODE", data["GROUPCODE"]);

              localStorage.setItem("userInfo", result.B2B_GET_USERResult);
              // localStorage.setItem('plasiyer',vm.veriler[0].plasiyer)
              // localStorage.setItem('serkan',vm.veriler[0].id)
            }
          } catch (error) {
            vs.notify({
              iconPack: "feather",
              color: "danger",
              icon: "icon-alert-circle",
              title: "Mail gönderilemedi",
              text: `Girilen kullanıcı adıyla herhangi bir mail adresi uyuşmuyor`
            });
          }
        });
      });
    });
  },
  logout({ commit }) {
    commit("clearToken");
    router.push("/login");
  }
};

export default actions;
